import { GenericResponse } from './../model/genericResponse';
import { Observable } from 'rxjs';
import { SharedFunctions } from './../shared.functions';
import { HttpClient } from '@angular/common/http';
import { SaveUnidadMedidaDto, UnidadMedidaDto, SearchUnidadMedidaRequest } from './../model/unidadMedidaMateriales';
import { CrudService } from '.';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UnidadMedidaService extends CrudService<UnidadMedidaDto, number, SaveUnidadMedidaDto, SearchUnidadMedidaRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'UnidadMedidaMaterial', sharedFunctions);

  }
 
}
